import React, { useEffect, useState } from "react";
import "./Topbar.css";
import {
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

const Topbar = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const today = new Date();
    const options = { weekday: "short", year: "numeric", month: "short", day: "numeric" };
    setCurrentDate(today.toLocaleDateString("en-US", options));
  }, []);

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <div className={`topbar ${darkMode ? "dark-mode" : ""}`}>
      <div className="container-fluid d-flex justify-content-between align-items-center">
        {/* Left */}
        <div className="topbar-left fw-bold">
          <span className="me-3">📞 +91-0135-3598009</span>
          <span>📧 northpointdehradun@gmail.com</span>
        </div>

        {/* Center */}
        <div className="topbar-center fw-bold">
          <span>{currentDate}</span>
        </div>

        {/* Right */}
        <div className="topbar-right d-flex align-items-center fw-bold">
          {/* <a href="/contact" className="top-link me-3">Contact Us</a> */}
          <a href="/onlineregister" className="top-link me-3">Online Registration</a>

          <a href="https://www.facebook.com/northpointdoon/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebookF /></a>
          <a href="https://www.youtube.com/@northpointdehradun/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaYoutube /></a>
          <a href="https://www.linkedin.com/in/northpoint-children-sacademy-0baa22405" target="_blank" rel="noopener noreferrer" className="social-icon"><FaLinkedinIn /></a>
          <a href="https://www.instagram.com/northpointgarhicantt/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
          <a href="https://wa.me/919456311713" target="_blank" rel="noopener noreferrer" className="social-icon"><FaWhatsapp /></a>

          <button onClick={toggleTheme} className="btn btn-sm btn-outline-light ms-3 theme-toggle">
            {darkMode ? "☀️ Light" : "🌙 Dark"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Topbar;